import { Controller, useFormContext } from "react-hook-form";
import React from "react";
import clsx from "clsx";
const SimpleCheckbox = ({ name, value, className, children }) => {
    const { control, formState: { errors } } = useFormContext(); // useFormContext to get the methods from parent
    return (React.createElement(Controller, { name: name, control: control, render: ({ field }) => (React.createElement("div", { className: "form-check" },
            React.createElement("input", Object.assign({ className: clsx("form-check-input", className, { "is-invalid": errors && errors[name] }), type: "checkbox" }, field, { value: value, checked: field.value, onChange: (e) => field.onChange(e.target.checked) })),
            React.createElement("label", { className: "form-check-label" }, children))) }));
};
export default SimpleCheckbox;
